export function tickFormatForDateDomain(domain: [number, number]) {
  const startDate = new Date(domain[0]);
  const endDate = new Date(domain[1]);

  // If on the first of the month, show the month and year
  if (startDate.getMonth() === 0 && startDate.getDate() === 1 && endDate.getMonth() === 11 && endDate.getDate() === 1) {
    return (d) => new Date(d).toLocaleString("default", { month: "long", year: "numeric" });
  }

  // Spans multiple years, use those
  if (startDate.getFullYear() !== endDate.getFullYear()) {
    return (d) => new Date(d).getFullYear();
  }

  // Otherwise, show the day, month, and year
  return (d) => new Date(d).toLocaleString("default", { day: "numeric", month: "short", year: "numeric" });
}